module.exports = __webpack_public_path__ + "static/4-mission1-Img-16c6b60f913e9118c3b427b2713a1bb0.png";